import SystemConfig, {CONFIG_PARAMS} from "../../system/SystemConfig";
import Wallet from "../../wallet/Wallet";

export function initDOM(wallet: Wallet, config: SystemConfig, wrapper: HTMLElement) {

    if(wallet.getLines().length > 1) {
        wrapper.classList.add("type-lines");
    }


    (<any>window)['Translations'].initTranslation(config.get(CONFIG_PARAMS.LANGUAGE));

}

